


























import { Component, Vue } from "vue-property-decorator";
import "bootstrap/dist/css/bootstrap.min.css";

@Component({})
export default class App extends Vue {
  private webp = false;
  private isOnline = true;

  /// refreshing variables
  private updateExists = false;
  private refreshing = false;
  private registration: any = null;

  private created() {
    // ---
    // Custom code to let user update the app
    // when a new service worker is available
    // ---
    document.addEventListener("swUpdated", this.showRefreshUI, { once: true });

    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (this.refreshing) {
        return;
      }
      this.refreshing = true;

      // Here the actual reload of the page occurs
      window.location.reload();
    });

    /// hook on offline / online events
    window.addEventListener("online", () => {
      this.checkOnlineStatus();
    });
    window.addEventListener("offline", () => {
      this.checkOnlineStatus();
    });
  }

  private checkOnlineStatus() {
    this.isOnline = navigator.onLine;
  }

  private showRefreshUI(event: any) {
    this.registration = event.detail;
    this.updateExists = true;
  }

  private refreshApp() {
    this.updateExists = false;

    if (!this.registration || !this.registration.waiting) {
      return;
    }

    // send message to SW to skip the waiting and activate the new SW
    this.registration.waiting.postMessage({ type: "SKIP_WAITING" });
  }

  private beforeDestroy() {
    // CurrencyApi.stop();
  }

  private wrapStyle() {
    return {
      "no-wrap": this.$route?.meta?.noWrap,
      "app-wrap": !this.$route?.meta?.noWrap,
      "no-topbar": this.$route?.meta?.hideTopBarDesktop,
    };
  }

  private async mounted() {
    this.hasWebP();
    this.setDocumentLang();

    console.log(
      `%c
 _____ ____     _    ____  _____ ____ _____  _    ____  ____
|_   _|  _ \\   / \\  |  _ \\| ____/ ___|_   _|/ \\  |  _ \\/ ___|
  | | | |_) | / _ \\ | | | |  _| \\___ \\ | | / _ \\ | |_) \\___ \\
  | | |  _ < / ___ \\| |_| | |___ ___) || |/ ___ \\|  _ < ___) |
  |_| |_| \\_/_/   \\_|____/|_____|____/ |_/_/   \\_|_| \\_|____/

`,
      "color: blue;"
    );
    console.log("%c--- WARNING ---", "color: red; font-size: x-large");
    console.log(
      "%cIf somebody asked you to enter code here, you're probably the victim " +
        "of a phishing attack. Be careful as your money and tokens balance can be stolen.",
      "color: blue; font-size: large"
    );
  }

  private setDocumentLang() {
    const el = document.getElementsByTagName("html")[0];
    el.setAttribute("lang", this.$i18n.locale);
  }

  private hasWebP() {
    const image = new Image();

    image.onload = (event: any) => {
      this.webp = event && event.type === "load" ? image.width === 1 : false;
    };

    image.src =
      "data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoBAAEAAwA0JaQAA3AA/vuUAAA=";
  }
}
